<!-- <app-suicide-prevention
  class="d-flex flex-column align-content-between vh-100"
  (errorMsg)="onError($event)"
></app-suicide-prevention> -->

<router-outlet></router-outlet>
